module.exports = __webpack_public_path__ + "img/Truppführer_Sp.79ca0b05.svg";